module.exports = __webpack_public_path__ + "media/03-sol-serotonin.865b6c4c.mp4";